import template from './template-export.html';
import controller from './template-export.controller';

export default {
	path: '/template-export',
	title: 'common.workspace',
	template,
	controller,
};
